import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";
import LabelLift from "../UI/LabelLift";
import LiftLine from "./components/LiftLine";

const Lift9 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift9"
			 className={getLiftClass(isOpen, activeLiftId === '9', state)}
			 transform="translate(1665.000000, 1229.000000)"
		>
			<LiftLine x1="36" y1="76" x2="130" y2="289" id="Line" color={colors[0]}/>

			<LiftLabelTypeSeat
				seatCount="3"
				colors={getLiftStatusColors(state, isOpen)}
				coords="47.903882, 131.173353"
				isOpen={isOpen}
				animationPart={3}
			/>

			<LiftLine x1="13.5471296" y1="13.5471296" x2="20.9145765" y2="40.8987768" color={colors[0]}/>

			<g id="Labe-lift" className="lift-label">
				<circle fill={colors[1]} fillRule="evenodd" cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" fillRule="evenodd" cx="13" cy="13" r="10"/>
				<text fontFamily="OpenSans-Bold, Open Sans" fontSize="12" fontWeight="normal"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(13.547130, 13.547130) scale(-1, 1) rotate(-76.000000) translate(-13.547130, -13.547130) "
				points="8.04712957 13.5471296 19.0471296 8.04712957 16.6756423 13.5471296 19.0471296 19.0471296"/>

			<LabelLift coords="118.000000, 277.000000" text={<tspan x="0.5" y="13.5">9</tspan>} isOpen={isOpen} state={state}/>
		</g>
	);
};

export default Lift9;
